export const INCIDENCIAS_REQUEST = 'INCIDENCIAS_REQUEST'
export const INCIDENCIAS_SUCCESS = 'INCIDENCIAS_SUCCESS'
export const INCIDENCIAS_ERROR = 'INCIDENCIAS_ERROR'

export const SEGUIMIENTO_REQUEST = 'SEGUIMIENTO_REQUEST'
export const SEGUIMIENTO_SUCCESS = 'SEGUIMIENTO_SUCCESS'
export const SEGUIMIENTO_ERROR = 'SEGUIMIENTO_ERROR'